import i18n from './i18n';
export default {
  NODE_ENV: process.env.VUE_APP_NODE_ENV,
  BASE_API_URL: process.env.VUE_APP_BASE_API_URL,
  APP_URL: process.env.VUE_APP_URL,
  API_DOMAIN: process.env.VUE_APP_API_DOMAIN,
  SERVER_URL: process.env.VUE_APP_SERVER_URL,
  IPDATA_API_KEY: process.env.VUE_APP_IPDATA_API_KEY,
  STRIPE_KEY: process.env.VUE_APP_STRIPE_KEY,
  APP_VERSION: process.env.VUE_APP_BUILD_VERSION,
  PAYPAL_CLIENT_ID: process.env.VUE_APP_PAYPAL_CLIENT_ID,
  PAYPAL_DONATION_URL: process.env.VUE_APP_PAYPAL_DONATION_URL,
  CLOUD_ANALYTICS_URL:process.env.VUE_APP_CLOUD_ANALYTICS_URL,
  MUX_ENV_KEY: process.env.VUE_APP_MUX_ENV_KEY,
  FIREBASE_DATABASE_URL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  FIREBASE_API_KEY: process.env.VUE_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.VUE_APP_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,

  /* Layouts of app */
  USE_ROOT: {
    root: true,
  },
  LAYOUT_GUEST: 'LAYOUT_GUEST',
  LAYOUT_COMPANY: 'LAYOUT_COMPANY',
  LAYOUT_AUTH: 'LAYOUT_AUTH',
  LAYOUT_NO: 'LAYOUT_NO',

  SUCCESS_COLOR: 'green',
  ERROR_COLOR: 'error',
  SESSION_MODE_CONSUMER: 'consumer',
  ERROR_TYPE: {
    NOT_ENROLLED_IN_SCREENING: 1030,
  },

  THEME: {
    PLATFORM: {
      COLORS: {
        PRIMARY: '#51FFBD',
        SECONDARY: '#ffffff',
        BACKGROUND: '#000000',
      },
      RTL: false,
      LOCALE: 'en',
    },
  },
  DEFAULT_FONTS : {
    text: 'Alef',
    value: 'Alef',
    url: 'https://fonts.gstatic.com/s/alef/v12/FeVfS0NQpLYgrjJbC5FxxbU.ttf'
  },

  DEFAULT_COUNTRY_CODE: 'GB', //United Kingdom
  SUPPORT_EMAIL: 'support@filmdiy.com',
  // Add to calendar
  ADD_TO_CAL_BASE_URL: 'https://www.google.com/calendar/render?',
  // MultiStreams
  ZoomMeeting: 'ZoomMeeting',
  VimeoLiveStream: 'VimeoLiveStream',
  MovieStream: 'MovieStream',
  VimeoChatStream: 'VimeoChatStream',
  LiveChat: 'LiveChat',
  FacebookLiveStream: 'FacebookLiveStream',
  YoutubeLiveStream: 'YoutubeLiveStream',
  JitsiLiveStream: 'JitsiLiveStream',
  WhereByMeeting:"WhereByMeeting",
  LiveWebinar:"LiveWebinar",
  MediaStream: "MediaStream",
  DailyCo:"daily.co",
  iFrame: 'iFrame',
  // Monetization
  MONETIZATION: {
    PRICING_TYPE: {
      SINGLE_PURCHASE: 10 /* Type for purchasing single screening */,
      GROUP_PURCHASE: 20 /* Type for purchasing group of screenings */,
      VOD_PURCHASE: 30 /* Type for VOD events */,
      PHYSICAL_TICKET_PURCHASE: 40 /* Type for physical event ticket */,
      SUBSCRIPTION: 50 /* Type for VOD subscription */
    },
    CURRENCIES: [
      {
        name: 'DKK - Danish Krone',
        value: 'DKK',
        symbol: 'Kr',
      },
      {
        name: 'EUR - Euro',
        value: 'EUR',
        symbol: '€',
      },
      {
        name: 'GBP - British Pound',
        value: 'GBP',
        symbol: '£',
      },
      {
        name: 'ILS - Israeli New Shekel',
        value: 'ILS',
        symbol: '₪',
      },
      {
        name: 'RON - Romanian Leu',
        value: 'RON',
        symbol: 'Lei',
      },
      {
        name: 'USD - US Dollar',
        value: 'USD',
        symbol: '$',
      },
      {
        name: 'CHF - Swiss Franc',
        value: 'CHF',
        symbol: 'Fr.'
      }
    ],
  },
  ENROLLMENT_STEPS: {
    LOGIN: 'login',
    VERIFICATION: 'verification',
    ASK_PHONE: 'ask_phone',
    VERIFICATION_PHONE: 'verification_phone',
    WANT_TO_SET_PASSWORD: 'want_to_set_password',
    CHANGE_PASSWORD: 'change_password',
    PAYMENT: 'payment',
    ASK_PASSWORD: 'ask_password',
    ASK_OTP: 'ask_otp',
    ASK_NAME_AND_PHONE: 'ask_name_and_phone',
    SELECT_PRICING_PLAN: 'select_pricing_plan',
    SELECT_EVENT_TYPE: 'select_event_type',
    SELECT_SEATS: 'select_seats',
    ASK_APP_LOGIN_CONFIRMATION: 'ask_app_login_confirmation'
  },
  /*
  As enrollment component is serving multi purpose, that's why using defined mode of use.
  Using in case of pass purchase.
  */
  ENROLLMENT_COMP:{
    MODE_OF_USE: {
      EVENT:"SCREENER",
      PASS:"PASS",
      SUBSCRIPTION:"SUBSCRIPTION"
    }
  },
  // Movies Everywhere's own terms page link
  MOVIES_EVERYWHERE_TERMS_PAGE_LINK: 'https://www.movieseverywhere.net/terms-and-privacy/',
  CUSTOM_URLS_ON_PLAYER: {
    // Dummy url for agora
    186: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/UBoV1pnoN5',
    },
    220: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/4n8artEfXW',
    },
    202: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/UBoV1pnoN5',
    },
    203: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/RANxyDzRTV',
    },
    205: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/z0vRdfXExE',
    },
    206: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/FEA2vEjLCy',
    },
    207: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/gKIjKZdhVt',
    },
    208: {
      text: 'לחצו להצבעה לסרט בתחרות פרס הקהל',
      url: 'https://top.scenaric.com/deck/1IO4aQwTFQ',
    },
  },
  SCREENER_OCCUPIED_SEATS_PERCENTAGE: 75, // Used to show available seats


  /**
   * STREAMING NETWORK ERROR CODES
   */

  EVENT_NOT_STARTED: 425,
  EVENT_FINISHED: 555,
  TOKEN_MISSING: 551,
  TOKEN_MISMATCH: 552,
  UNENROLLED: 553,
  GEO_BLOCKED: 557,
  SESSION_DELETED: 556,
  SERVER_ERROR: 500,
  EVENT_EXPIRED: 410,
  MANIFEST_LOAD_ERROR:"manifestLoadError",
  EVENT_TYPE: {
    STANDARD_EVENTS: 'StandardEvents',
    VOD_EVENTS: 'VodEvents'
  },
  CLOUD_ANALYTICS_KEY:"b7cdfbc8-a90e-4292-b514-8bfa06735ce6",
  SCREENER_TYPE_STR: {
    10: 'defines.screener_type_str.virtual',
    20: 'defines.screener_type_str.physical',
    50: 'defines.screener_type_str.virtual_and_physical',
  },
  SCREENER_TYPE_VALUE: {
    VIRTUAL: 10,
    PHYSICAL: 20,
    VIRTUAL_AND_PHYSICAL: 50,
    SUBSCRIPTION: 60
  },
  SEATS_STATUS:{
    AVAILABLE:10,
    LOCKED:20,
    BOOKED:30,
  },
  SEATS_STATUS_CLASSES:{
    SELECTED:'cls-seat-selected',
    AVAILABLE:'cls-seat-available',
    LOCKED:'cls-seat-reserved',
    BOOKED:'cls-seat-booked'
  },
  SEATS_CATEGORIES:{
    10:{
      label:'screener.seats.category.regular.title',
      value:10,
      colorClass:"cls-seat-category-regular"
    },
    20:{
      label:'screener.seats.category.cheaper.title',
      value:20,
      colorClass:"cls-seat-category-cheaper"
    },
    30:{
      label:'screener.seats.category.premium.title',
      value:30,
      colorClass:"cls-seat-category-premium"
    },
    40:{
      label:'screener.seats.category.disabled.title',
      value:40,
      colorClass:"cls-seat-category-disabled"
    }
  },
  BOOKING_STATUS_STR:{
    10: 'screener.booking.status.cancelled.label',
    20: 'screener.booking.status.locked.label',
    30: 'screener.booking.status.payment_initiated.label',
    35: 'screener.booking.status.payment_failed.label',
    40: 'screener.booking.status.booked.label'
  },

  FIREPLACE_AD_COMPANY_ID: 56,
  FIREPLACE_AD_SCREENER_ID: 849,
  SEATS_TICKET_TYPES : {
    10:{
      label: 'screener.seats.ticket.type.child.title',
      value: 10
    },
    20:{
      label: 'screener.seats.ticket.type.student.title',
      value: 20
    },
    30:{
      label: 'screener.seats.ticket.type.senior.title',
      value: 30
    },
    0:{
      label: 'screener.seats.ticket.type.none.title',
      value: 0
    }
  },
  SEAT_TICKET_TYPES_LABEL: {
    10 : 'CHILD',
    20 : 'STUDENT',
    30 : 'SENIOR',
  },
  DEFAULT_SEAT_TICKET_TYPE:0,
  PAYMENT_GATEWAYS:{
    STRIPE:{
      name: 'screener.payment_gateway.stripe.title',
      value: "stripe",
      statement_descriptor:"FILM RENT*"
    },
    PAYPAL:{
      name: 'screener.payment_gateway.paypal.title',
      value: "paypal"
    },
    ADMIN_PAY:{
      name: 'screener.payment_gateway.admin_pay.title',
      value: "admin_pay"
    }
  },
  HOMEPAGE_LINK:"https://watch.movieseverywhere.net/",

  /**
   * Event manager state
   */
   EVENT_MANAGER_STATE: {
    INITIALIZING:       "INITIALIZING",
    INTERRUPTED:        "INTERRUPTED",
    ACTIVE:             "ACTIVE",
    ERROR:              "ERROR"
  },

  PLAYER_CONFIG: {
    GLOBAL: {
      mute: false,
      subtitle_lang: "english",
      resolution: "auto"
    },
    SCREENER: {
      currentMovieIndex: 0,
      currentFilmId: null,
      currentTime: 0,
      prerollEnded: false,
      subtitle_lang: null,
      resolution: "auto",
      fullEventWatched: false
    }
  },
  PURCHASE_STATUS:{
    INITIATED:10,
    PROCESSING:20,
    COMPLETED:30,
  },
  LOCALES: [
    {
      text: 'Hebrew',
      value: 'he',
    },
    {
      text: 'English',
      value: 'en',
    },
    {
      text: 'Spanish',
      value: 'es',
    },
    {
      text: 'Italian',
      value: 'it',
    },
  ],
  CHATROOM_MEMBERS: {
    validation: {
      bio:300
    }
  },
  CHAT_MESSAGE_RECTIONS:[
    '👍',
    '❤️',
    '😂',
    '😮',
    '😢',
    '🙏',
  ],
  BE_IN_INFO_VIDEO_URL: 'https://player.vimeo.com/external/1013208036.m3u8?s=11af99bce7a45f32853e3ebbf0b4e5a5f553d1de&logging=false',

  PRICING_PLANS: {
    month: {
      features: [
        i18n.t('company.plan.month.feature.1'),
        i18n.t('company.plan.month.feature.2'),
        i18n.t('company.plan.month.feature.3'),
        i18n.t('company.plan.month.feature.4')
      ],
      checkoutNote: i18n.t('company.plan.checkout.note')
    },
    year: {
      features: [
        i18n.t('company.plan.year.feature.1'),
        i18n.t('company.plan.year.feature.2'),
        i18n.t('company.plan.year.feature.3'),
        i18n.t('company.plan.year.feature.4')
      ],
      checkoutNote: i18n.t('company.plan.checkout.note')
    }
  },
  SUBSCRIPTION:{
    STATUS:{
      TRIALING: 'trialing',
      CANCELED: 'canceled',
      ACTIVE: 'active'
    },
    INVOICE: {
      STATUS: {
        PAID: 'paid',
        DUE: 'due',
        DRAFT: 'draft',
      },
    },
  },

};
